// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: fvWUsFaeQiIk
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import InviteUserCard from "../../InviteUserCard"; // plasmic-import: pVyxXczk01pM/component
import { AntdInputNumber } from "@plasmicpkgs/antd5/skinny/registerInput";
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicBillingSettings.module.css"; // plasmic-import: fvWUsFaeQiIk/css

createPlasmicElementProxy;

export const PlasmicBillingSettings__VariantProps = new Array();

export const PlasmicBillingSettings__ArgProps = new Array("bankName");

const $$ = {};

function PlasmicBillingSettings__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "numberInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "numberInput2.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <Stack__
            as={"div"}
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            hasGap={true}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"billingDetailsStack"}
              data-plasmic-override={overrides.billingDetailsStack}
              hasGap={true}
              className={classNames(projectcss.all, sty.billingDetailsStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__fxOVk)}>
                <div
                  data-plasmic-name={"title9"}
                  data-plasmic-override={overrides.title9}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.title9
                  )}
                >
                  {"Banking Details"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___2CnZp)}>
                <div className={classNames(projectcss.all, sty.freeBox__gWtxd)}>
                  <div
                    data-plasmic-name={"title13"}
                    data-plasmic-override={overrides.title13}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.title13
                    )}
                  >
                    {"Bank Account:"}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___9XwYy)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__ceBuf
                          )}
                        >
                          {"Not Linked"}
                        </div>
                      ),

                      value: args.bankName,
                      className: classNames(sty.slotTargetBankName)
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"linkBank"}
                  data-plasmic-override={overrides.linkBank}
                  className={classNames(projectcss.all, sty.linkBank)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___9MbGn
                    )}
                  >
                    {"Link Bank"}
                  </div>
                </div>
              </div>
            </Stack__>
            <div
              data-plasmic-name={"inviteUsersStack"}
              data-plasmic-override={overrides.inviteUsersStack}
              className={classNames(projectcss.all, sty.inviteUsersStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__zUsDj)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__gYp0R
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h4
                        data-plasmic-name={"inviteUsersHeading"}
                        data-plasmic-override={overrides.inviteUsersHeading}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.inviteUsersHeading
                        )}
                      >
                        {"Invite Users"}
                      </h4>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox___8Xvx5)}>
                <div
                  data-plasmic-name={"inviteUsersBtn"}
                  data-plasmic-override={overrides.inviteUsersBtn}
                  className={classNames(projectcss.all, sty.inviteUsersBtn)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__n2K6O
                    )}
                  >
                    {"Invite User"}
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__gUo
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h6
                        className={classNames(
                          projectcss.all,
                          projectcss.h6,
                          projectcss.__wab_text,
                          sty.h6__ly4Iv
                        )}
                      >
                        {"User List:"}
                      </h6>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__aZJvG)}>
                <div
                  data-plasmic-name={"userListStack"}
                  data-plasmic-override={overrides.userListStack}
                  className={classNames(projectcss.all, sty.userListStack)}
                >
                  <InviteUserCard
                    data-plasmic-name={"inviteUserCard"}
                    data-plasmic-override={overrides.inviteUserCard}
                    className={classNames("__wab_instance", sty.inviteUserCard)}
                    userName={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__wyH33
                        )}
                      >
                        {"joedoe@gmail.com"}
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"paymentOptionsContainer"}
              data-plasmic-override={overrides.paymentOptionsContainer}
              className={classNames(
                projectcss.all,
                sty.paymentOptionsContainer
              )}
            >
              <div className={classNames(projectcss.all, sty.freeBox__ofuIr)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__i61Ji
                  )}
                >
                  <React.Fragment>
                    <React.Fragment>{""}</React.Fragment>
                    {
                      <h4
                        data-plasmic-name={"inviteUsersHeading2"}
                        data-plasmic-override={overrides.inviteUsersHeading2}
                        className={classNames(
                          projectcss.all,
                          projectcss.h4,
                          projectcss.__wab_text,
                          sty.inviteUsersHeading2
                        )}
                      >
                        {"Debtor Payment Options"}
                      </h4>
                    }

                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__qgyVm)}>
                <div className={classNames(projectcss.all, sty.freeBox__lvdd)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___89NAn)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__jvx0L)}
                    >
                      <h6
                        className={classNames(
                          projectcss.all,
                          projectcss.h6,
                          projectcss.__wab_text,
                          sty.h6__r20L
                        )}
                      >
                        {"Minimum Settlement Percentage:"}
                      </h6>
                      <AntdInputNumber
                        data-plasmic-name={"numberInput"}
                        data-plasmic-override={overrides.numberInput}
                        className={classNames(
                          "__wab_instance",
                          sty.numberInput
                        )}
                        onChange={async (...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "numberInput",
                            "value"
                          ]).apply(null, eventArgs);
                        }}
                        placeholder={"Percentage"}
                        type={"number"}
                        value={generateStateValueProp($state, [
                          "numberInput",
                          "value"
                        ])}
                      />
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__aMe86)}
                    >
                      <h6
                        className={classNames(
                          projectcss.all,
                          projectcss.h6,
                          projectcss.__wab_text,
                          sty.h6___0G6If
                        )}
                      >
                        {"Maximum Payment Plan Length in Months:"}
                      </h6>
                      <AntdInputNumber
                        data-plasmic-name={"numberInput2"}
                        data-plasmic-override={overrides.numberInput2}
                        className={classNames(
                          "__wab_instance",
                          sty.numberInput2
                        )}
                        onChange={async (...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "numberInput2",
                            "value"
                          ]).apply(null, eventArgs);
                        }}
                        placeholder={"Months"}
                        type={"number"}
                        value={generateStateValueProp($state, [
                          "numberInput2",
                          "value"
                        ])}
                      />
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__kN2JO)}
                    >
                      <Button
                        data-plasmic-name={"button"}
                        data-plasmic-override={overrides.button}
                        className={classNames("__wab_instance", sty.button)}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text__n9LBu
                          )}
                        >
                          {"Save"}
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__o0BBn
                  )}
                >
                  {""}
                </div>
              </div>
            </div>
          </Stack__>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "billingDetailsStack",
    "title9",
    "title13",
    "linkBank",
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack",
    "inviteUserCard",
    "paymentOptionsContainer",
    "inviteUsersHeading2",
    "numberInput",
    "numberInput2",
    "button"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "billingDetailsStack",
    "title9",
    "title13",
    "linkBank",
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack",
    "inviteUserCard",
    "paymentOptionsContainer",
    "inviteUsersHeading2",
    "numberInput",
    "numberInput2",
    "button"
  ],

  billingDetailsStack: ["billingDetailsStack", "title9", "title13", "linkBank"],
  title9: ["title9"],
  title13: ["title13"],
  linkBank: ["linkBank"],
  inviteUsersStack: [
    "inviteUsersStack",
    "inviteUsersHeading",
    "inviteUsersBtn",
    "userListStack",
    "inviteUserCard"
  ],

  inviteUsersHeading: ["inviteUsersHeading"],
  inviteUsersBtn: ["inviteUsersBtn"],
  userListStack: ["userListStack", "inviteUserCard"],
  inviteUserCard: ["inviteUserCard"],
  paymentOptionsContainer: [
    "paymentOptionsContainer",
    "inviteUsersHeading2",
    "numberInput",
    "numberInput2",
    "button"
  ],

  inviteUsersHeading2: ["inviteUsersHeading2"],
  numberInput: ["numberInput"],
  numberInput2: ["numberInput2"],
  button: ["button"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBillingSettings__ArgProps,
          internalVariantPropNames: PlasmicBillingSettings__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBillingSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBillingSettings";
  } else {
    func.displayName = `PlasmicBillingSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicBillingSettings = Object.assign(
  // Top-level PlasmicBillingSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    billingDetailsStack: makeNodeComponent("billingDetailsStack"),
    title9: makeNodeComponent("title9"),
    title13: makeNodeComponent("title13"),
    linkBank: makeNodeComponent("linkBank"),
    inviteUsersStack: makeNodeComponent("inviteUsersStack"),
    inviteUsersHeading: makeNodeComponent("inviteUsersHeading"),
    inviteUsersBtn: makeNodeComponent("inviteUsersBtn"),
    userListStack: makeNodeComponent("userListStack"),
    inviteUserCard: makeNodeComponent("inviteUserCard"),
    paymentOptionsContainer: makeNodeComponent("paymentOptionsContainer"),
    inviteUsersHeading2: makeNodeComponent("inviteUsersHeading2"),
    numberInput: makeNodeComponent("numberInput"),
    numberInput2: makeNodeComponent("numberInput2"),
    button: makeNodeComponent("button"),
    // Metadata about props expected for PlasmicBillingSettings
    internalVariantProps: PlasmicBillingSettings__VariantProps,
    internalArgProps: PlasmicBillingSettings__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicBillingSettings;
/* prettier-ignore-end */
